import React from "react";
import { Switch, useHistory } from "react-router-dom";
import ReactGA from "react-ga4";
import { HomeBuilderRouter as HomeBuilderRouter } from "./HomeBuilderRouter";
import { AuthProvider } from "../../usecases/Auth";

export const Router: React.FC = () => {
  const history = useHistory();

  const trackPageView = React.useCallback(() => {
    ReactGA.send("pageview");
  }, []);

  React.useEffect(() => {
    trackPageView();
    history.listen(trackPageView);
  }, [history, trackPageView]);

  return (
    <Switch>
      <AuthProvider>
        <HomeBuilderRouter />
      </AuthProvider>
    </Switch>
  );
};
